<ul class="socialIcons">
  <li class="fa fa-facebook fa-2x social"></li>
  <li class="fa fa-twitter fa-2x social"></li>
  <li class="fa fa-google-plus fa-2x social"></li>
</ul>
